import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';

export const HeaderStyled = styled('header')`
  z-index: ${globalZindex.content};
  display: flex;
  height: 50px;
  padding: 16px;
`;
